import { environment } from 'src/environment';
import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { StripeCardElementOptions, StripeElements, StripeElementsOptions, StripeCardNumberElementOptions } from '@stripe/stripe-js';
import {
  StripeCardComponent, StripeCardCvcComponent, StripeCardExpiryComponent,
  StripeCardGroupDirective,
  StripeCardNumberComponent, StripeService
} from 'ngx-stripe';
import { takeWhile } from 'rxjs/operators';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { DatalayerService } from 'src/app/core/services/datalayer.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { SessionService } from 'src/app/core/services/session.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import { emailRegex } from '../../constants';
import { COUPON } from '../../constants/key.constants';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { R_ACCOUNT_SETTINGS } from 'src/app/shared/constants/route.constants';
import { PaymentService } from 'src/app/core/services/payment.service';
declare var UIkit: any;
import * as $ from 'jquery';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import { StripeInfoComponent } from '../stripe-info/stripe-info.component';
import { ApplicationService } from 'src/app/core/services/application.service';
import { AdyenCheckout, Card } from '@adyen/adyen-web';
import { CoreConfiguration } from '@adyen/adyen-web';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';
@Component({
  selector: 'app-card-payment',
  templateUrl: './card-payment.component.html',
  styleUrls: ['./card-payment.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, StripeInfoComponent, StripeCardGroupDirective,
    StripeCardNumberComponent, StripeCardExpiryComponent, StripeCardCvcComponent,
    StripeCardComponent, ReactiveFormsModule, FormsModule, AlertBoxComponent]
})
export class CardPaymentComponent implements OnInit, OnDestroy {
  textColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-font-color-on-lbg');
  bgColor = getComputedStyle(document.documentElement).getPropertyValue('--bg-page');
  placeHolderColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-font-color');
  base: StripeElements;
  baseStyles: StripeCardElementOptions = {
    hidePostalCode: true,
    style: {
      base: {
        iconColor: '#666EE8',
        color: this.textColor,
        backgroundColor: this.bgColor,
        padding: '1px',
        lineHeight: '2.5',
        fontSize: '16px',
        '::placeholder': {
          color: this.placeHolderColor,
        },
      }
    }
  };
  cardOptions: StripeCardNumberElementOptions = {
    ...this.baseStyles,
    showIcon: true,
    iconStyle: 'solid',
  };

  elementsOptions: StripeElementsOptions = {
    locale: 'en',
  };

  cardNumberValidation;
  cardCvvValidation;
  cardExpiryValidation;
  susbId: any;
  payList: any;
  paymentType: any;
  payMethodLength: any;
  errorFound: any;
  errorResult: { already_subscribed: any; expired: any; invalid: any; };
  uId: any;
  region: any;
  locale: any;
  fingerPrintData: any;
  @ViewChild(StripeCardComponent) card;
  @ViewChild(StripeCardNumberComponent) cardNumber: StripeCardNumberComponent;
  @ViewChild(StripeCardExpiryComponent) cardExpiry: StripeCardExpiryComponent;
  @ViewChild(StripeCardCvcComponent) cardCVV: StripeCardCvcComponent;
  user: any;
  checkValueExist = true;
  nextBillingDate: any;
  buttonValue: string;
  oldUser = false;
  plan: any;
  stripeTest: any;
  @Input() payButton: boolean;
  // @Input() session_id: any;
  @Input() coupon_valid: String;
  @Output() emitCardPayment = new EventEmitter<{ url_data: any }>();
  private errRoute = '/auth/payment/error';
  private successRoute = '/auth/payment/success';
  private discountType: string;
  private discountCode: string;
  couponValid;
  paymentBtnDisabled = false;
  @ViewChild(AlertBoxComponent) alertBox: AlertBoxComponent;
  backButton = false;
  paymentProcessCheckAlive = true;
  @Input() page;
  freeTrialDays;

  skinName = environment.skinName;
  checkout: any;
  paymentGateway: any;
  adyencomp: any;
  ipAddress: any;

  constructor(private storageService: StorageService, private baseService: BaseService,
    private fb: FormBuilder, public configService: ConfigurationService,
    private route: ActivatedRoute, private sessionService: SessionService,
    private uikitService: UikitService, public subscriptionService: SubscriptionService,
    private router: Router, private stripeService: StripeService,
    public planService: PlanService, private datalayerService: DatalayerService,
    public dialog: MatDialog, private paymentService: PaymentService, private settingService: SettingsService,
    private applicationService: ApplicationService, private analyticsService: InhouseAnalyticsService) {
    this.region = this.storageService.getLocalStore('region');
    this.locale = this.storageService.getLocalStore('locale');
    history.pushState(null, document.title, location.href);
    this.elementsOptions.locale = this.configService.stripeLocaleCode;
    this.buttonValue = (this.configService.localeKeys?.["plans.please_wait.text"] || 'Please wait');
  }

  ngOnInit() {
    this.paymentGateway = this.settingService.paymentGateway;
    this.freeTrialDays = +this.storageService.getLocalStore('freeTrialDays');

    const querydata = this.route.snapshot.queryParams;
    this.couponValid = this.route.snapshot.params?.coupon_valid;
    this.baseService.loaderSource.next(true);
    if (querydata['session_id']) {
      this.subscriptionService.paymentSessionId = querydata['session_id'];
    }
    this.uId = this.storageService.getLocalStore('u_id');
    this.discountType = this.storageService.getLocalStore('discount_type');
    this.discountCode = this.storageService.getLocalStore('discount_code');
    if (this.discountType === COUPON && this.discountCode) {
      this.errRoute = '/voucher/payment/error';
      this.successRoute = '/voucher/success'
    }
    if (this.paymentGateway === 'adyen') {
      this.createAdyenCheckout();
    } else {
      this.stripeTest = this.fb.group({
        email: ['', [Validators.required, Validators.pattern(emailRegex)]],
        name: ['', [Validators.required, Validators.minLength(3)]],
      });
      if (this.planService.plansLength > 0) this.validateSession();
      this.baseService.paymentProcessing.next(false);
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.backButton = true;
    this.baseService.paymentProcessing
      .pipe(takeWhile(() => this.paymentProcessCheckAlive))
      .subscribe((value) => {
        if (value && this.backButton) {
          this.showAlertBox();
          if (history?.state !== null) {
            history.pushState(null, document.title, location.href);
          }
          this.backButton = false;
        } else if (!value && this.backButton) {
          this.backButton = false;
          const prevPaymentPathName = this.storageService.getLocalStore('prevPaymentPathName');
          location.href = prevPaymentPathName ? prevPaymentPathName : 'auth/plan';
        }
      });
  }


  showAlertBox() {
    const title = this.configService.localeKeys?.["plans.info_processed_do_not_press_back_button.text"] || "Your payment is in progress, please don't press the back button now as it can lead to payment failure.";
    const btnText = this.configService.localeKeys?.["plans.dismiss.text"];
    if (!this.dialog.openDialogs.length) {
      this.dialog.open(AlertBoxComponent, {
        data: { title, btnText },
        hasBackdrop: false,
        position: { top: '0px' }
      })
    } else {
      this.dialog.closeAll();
    }
  }

  validateSession() {
    this.sessionService.validateSession(this.subscriptionService.paymentSessionId).subscribe((resp) => {
      if (resp.status_code === 200) {
        const data = resp.data;
        this.susbId = data.session?.subscription_id;
        this.payList = data.stripe_payment_methods;
        this.paymentType = data.stripe_payment_methods ? data.stripe_payment_methods[0] : this.paymentType;
        this.payMethodLength = data.stripe_payment_methods?.length;
        this.paymentService.paymentMethodLength = this.payMethodLength;
        this.errorFound = (data.already_subscribed || data.expired || data.invalid);
        this.errorResult = {
          already_subscribed: data.already_subscribed, expired: data.expired, invalid: data.invalid
        };
        if (!this.errorFound) {
          const userPlanData = {
            session_id: this.subscriptionService.paymentSessionId,
            subscriptionId: this.susbId,
            fingerprint_checked: false,
            coupon_code: this.storageService.getLocalStore('discount_code')
          };
          this.invoiceUserPlan(userPlanData)
        }
        else {
          this.baseService.loaderSource.next(false);
          this.navErrPage();
        }
      } else {
        this.errorResult = {
          already_subscribed: false, expired: false, invalid: true
        };
        this.router.navigate([`${this.errRoute}`, 'invalid'])
        this.baseService.loaderSource.next(false);
      }
    }, (err) => {
      this.baseService.loaderSource.next(false);
      if (err.error && err.error.code !== 1002) {
        this.uikitService.notifyError(err);
      }
    });
  }

  navErrPage() {
    switch (true) {
      case (this.errorResult.already_subscribed):
        this.router.navigate([`${this.errRoute}`, 'susbcribed']);
        break;
      case (this.errorResult.expired):
        this.router.navigate([`${this.errRoute}`, 'expired']);
        break;
      case (this.errorResult.invalid):
        this.router.navigate([`${this.errRoute}`, 'invalid']);
        break;
      default:
        this.router.navigate([`${this.errRoute}`, 'invalid']);
        break;
    }
  }

  invoiceUserPlan(userPlanData) {
    this.subscriptionService.invoiceUserPlan(userPlanData).subscribe((data) => {
      if (data) {
        this.baseService.loaderSource.next(false);
        this.plan = data.plan;
        this.user = data.user;
        // this.billingDate = data.next_billing_date;
        // this.nextBillingDate = data.next_billing_date;
        // this.oneTime = data.one_time_subscription;
        this.stripeTest.setValue({
          name: this.user.name,
          email: this.user.email
        });
        this.nextBillingDate = data?.plan?.next_billing_date;
        const { user_type, one_time_subscription } = data.user;
        if (user_type || one_time_subscription || !this.payButton) {
          this.buttonValue = (this.freeTrialDays > 0) ? (this.storageService.getLocalStore('freeTrialText')) : (this.configService.localeKeys?.["plans.start_subscription.btn"] || 'Start subscription');
          this.oldUser = true;
        }
        if (!this.fingerPrintData?.fingerprint_checked) {
          this.buttonValue = (this.freeTrialDays > 0) ? (this.storageService.getLocalStore('freeTrialText')) : (this.configService.localeKeys?.["plans.start_subscription.btn"] || 'Start subscription');
        } else {
          this.buttonValue = this.configService.localeKeys?.["plans.start_subscription.btn"] || 'Start subscription';
        }
        const datalayerPaymentData = {
          event: 'purchase',
          eventCategory: 'Payment',
          eventAction: 'View',
          eventLabel: this.plan.title,//User’s selected plan and its price should be sent dynamically 
          eventValue: this.plan.amount, //Price value is should be sent with “.” delimiter. 
          nonInteraction: 'true'
        };
        this.datalayerService.addDatalayer(datalayerPaymentData);
        if (!this.user) {
          this.checkValueExist = false;
        }
      }
    });
  }

  cardPayItem(createSubsObj) {
    this.subscriptionService.createSubcription(createSubsObj).subscribe(
      (resp) => {
        const data = resp;
        const selectedPlan = this.storageService.getSessionStore('selectedPlanData');
        const userType = this.storageService.getLocalStore('user_type');
        const eventObj = {
          event_type: 'event',
          event_name: 'Submit Card Details',
          event_status: 'Success',
          discount_code: this.discountCode || '',
          value: selectedPlan.amount,
          payment_type: this.paymentGateway,
          subscription_status: userType,
          paid_user: userType,
          subscription_plan: selectedPlan.title,
        };
        this.analyticsService.trackUserActions(eventObj);

        const stripeSubscriptionId = data.stripe_subscription_id;
        if (resp?.action?.type === 'redirect') {
          // for 3d secure cards
          this.adyencomp.handleAction(resp.action);
          return;
        }
        if (data.status) {
          if (data.subscription_status === 'trialing' && data.setup_intent) {
            if (data.setup_intent.status === 'requires_source_action' || data.setup_intent.status === 'requires_action') {
              const clientSecretKey = data.setup_intent.client_secret;
              this.confirmCard(clientSecretKey, stripeSubscriptionId, 'setup');
            }
          } else if (data.subscription_status === 'incomplete' && data.payment_intent) {
            if (data.payment_intent.status === 'requires_source_action' || data.payment_intent.status === 'requires_action') {
              const clientSecretKey = data.payment_intent.client_secret;
              this.confirmCard(clientSecretKey, stripeSubscriptionId, 'payment');
            }
          } else {
            const keyQueryParamTV = this.route.snapshot.queryParams['app'];
            if (keyQueryParamTV === this.baseService.keyQueryParamTV) {
              data.url_data['app'] = this.baseService.keyQueryParamTV;
            } else if (keyQueryParamTV === this.baseService.keyQueryParamAppleTV) {
              data.url_data['app'] = this.baseService.keyQueryParamAppleTV;
            }
            if (this.successRoute === '/auth/payment/success') {
              this.paymentSuccessGTM(data?.url_data);
            }
            const livePage = this.router.url.match('/live/');
            if (this.router.url == R_ACCOUNT_SETTINGS || livePage?.length || this.page === 'contentDetail' || this.page === 'mobilePlan') {
              this.emitCardPayment.emit({ url_data: data.url_data });
              this.baseService.paymentProcessing.next(false);
            } else {
              this.router.navigate([`${this.successRoute}`], { queryParams: data.url_data });
              this.baseService.paymentProcessing.next(false);
            }
          }
        } else {
          this.baseService.paymentProcessing.next(false);
          this.baseService.loaderSource.next(false);
        }
      }, error => {
        // getting new session when the payment is failed
        this.subscriptionService.getNewSessionId().then(sessionId => {
          this.subscriptionService.paymentSessionId = sessionId;
        }).catch(error => {
          console.error('Error:', error);
        });

        this.adyencomp.setStatus('error');
        const selectedPlan = this.storageService.getSessionStore('selectedPlanData');
        const userType = this.storageService.getLocalStore('user_type');
        const eventObj = {
          event_type: 'event',
          event_name: 'Submit Card Details',
          event_status: 'Failure',
          discount_code: this.discountCode || '',
          value: selectedPlan.amount,
          payment_type: this.paymentGateway,
          subscription_status: userType,
          paid_user: userType,
          subscription_plan: selectedPlan.title,
          extra_info: error
        };
        this.analyticsService.trackUserActions(eventObj);
      });
  }

  confirmCard(clientSecretKey, stripeSubscriptionId, type) {
    if (type === 'setup') {
      this.stripeService.confirmCardSetup(clientSecretKey).subscribe(
        (response) => {
          this.cardAPIresponseHandler(response, stripeSubscriptionId)
        }
      );
    } else if (type === 'payment') {
      this.stripeService.confirmCardPayment(clientSecretKey).subscribe(
        (response) => {
          this.cardAPIresponseHandler(response, stripeSubscriptionId)
        }
      );
    }
  }

  cardAPIresponseHandler(response, stripeSubscriptionId) {
    if (response.error) {
      this.baseService.loaderSource.next(false);
      this.baseService.paymentProcessing.next(false);
      const errMsg = response.error?.message;
      this.paymentErrorGTM(errMsg);
      this.uikitService.staticErrorMessage(errMsg);
    } else {
      let completeSubsData = {
        region: this.region,
        locale: this.locale,
        session_id: this.subscriptionService.paymentSessionId,
        stripe_subscription_id: stripeSubscriptionId
      };
      if (this.discountType === COUPON && this.couponValid === '1') {
        completeSubsData['coupon_code'] = this.discountCode
      }
      if (this.fingerPrintData?.fingerprint_checked) {
        completeSubsData['fingerprint_checked'] = this.fingerPrintData.fingerprint_checked;
        completeSubsData['stripe_fingerprint'] = this.fingerPrintData.stripe_fingerprint;
        this.buttonValue = (this.configService.localeKeys?.["plans.start_subscription.btn"] || 'Start subscription');
        this.oldUser = true;
      }
      this.subscriptionService.completeSubcription(completeSubsData).subscribe(
        (resp) => {
          if (resp) {
            this.storageService.removeLocalStore('sessionId');
            const keyQueryParamTV = this.route.snapshot.queryParams['app'];
            if (keyQueryParamTV === this.baseService.keyQueryParamTV) {
              resp.url_data['app'] = this.baseService.keyQueryParamTV;
            } else if (keyQueryParamTV === this.baseService.keyQueryParamAppleTV) {
              resp.url_data['app'] = this.baseService.keyQueryParamAppleTV;
            }
            if (this.successRoute === '/auth/payment/success') {
              this.paymentSuccessGTM(resp?.url_data);
            }
            const livePage = this.router.url.match('/live/');
            if (this.router.url == R_ACCOUNT_SETTINGS || livePage?.length) {
              this.emitCardPayment.emit({ url_data: resp.url_data });
              this.baseService.paymentProcessing.next(false);
            } else {
              this.router.navigate([`${this.successRoute}`], { queryParams: resp.url_data });
            }
            this.baseService.loaderSource.next(false);
          }
        }, error => {
          // getting new session when the payment is failed
          this.subscriptionService.getNewSessionId().then(sessionId => {
            this.subscriptionService.paymentSessionId = sessionId;
          }).catch(error => {
            console.error('Error:', error);
          });
        });
    }
  }

  checkFingerPrint(createSubsObj) {
    let checkFingerPrintData = {
      locale: this.locale,
      region: this.region,
      session_id: this.subscriptionService.paymentSessionId,
      payment_method: createSubsObj['payment_method']
    }
    if (this.discountType === COUPON && this.couponValid == 1) {
      checkFingerPrintData['coupon_code'] = this.discountCode;
      createSubsObj['coupon_code'] = this.discountCode;
    }
    if (this.fingerPrintData?.fingerprint_checked) {
      checkFingerPrintData['fingerprint_checked'] = this.fingerPrintData?.fingerprint_checked;
      checkFingerPrintData['stripe_fingerprint'] = this.fingerPrintData?.stripe_fingerprint;
      this.buttonValue = (this.configService.localeKeys?.["plans.start_subscription.btn"] || 'Start subscription');
      this.oldUser = true;
    }
    this.subscriptionService.fingerPrintCheck(checkFingerPrintData).subscribe(res => {
      const respData = res;
      const selectedPlan = this.storageService.getSessionStore('selectedPlanData');
      const userType = this.storageService.getLocalStore('user_type');
      const eventObj = {
        event_type: 'event',
        event_name: 'Check Fingerprint',
        event_status: 'Success',
        discount_code: this.discountCode || '',
        value: selectedPlan.amount,
        payment_type: this.paymentGateway,
        subscription_status: userType,
        paid_user: userType,
        subscription_plan: selectedPlan.title,
      };
      this.analyticsService.trackUserActions(eventObj);

      if (respData.fingerprint_checked) {
        this.fingerPrintData = {
          fingerprint_checked: respData.fingerprint_checked,
          stripe_fingerprint: respData.stripe_fingerprint
        };
        this.fingerPrintPopup(this.fingerPrintData);
        this.baseService.loaderSource.next(false);
      } else {
        this.cardPayItem(createSubsObj);
      }
    }, err => {
      const selectedPlan = this.storageService.getSessionStore('selectedPlanData');
      const userType = this.storageService.getLocalStore('user_type');
      const eventObj = {
        event_type: 'event',
        event_name: 'Check Fingerprint',
        event_status: 'Failure',
        discount_code: this.discountCode || '',
        value: selectedPlan.amount,
        payment_type: this.paymentGateway,
        subscription_status: userType,
        paid_user: userType,
        subscription_plan: selectedPlan.title,
      };
      this.analyticsService.trackUserActions(eventObj);
    });
  }


  fingerPrintPopup(data) {
    $('#fingerprint-confirm-modal').addClass('uk-open').show()
  }

  fingerPrintTryAgain(id) {
    UIkit.modal(id).hide();
    this.cardExpiry.element.clear();
    this.cardCVV.element.clear();
    this.cardNumber.element.clear();
    this.fingerPrintData = { fingerprint_checked: false, stripe_fingerprint: undefined };
  }

  fingerPrintProceed(id) {
    UIkit.modal(id).hide();
    const userPlanData = {
      session_id: this.subscriptionService.paymentSessionId,
      subscriptionId: this.susbId,
      fingerprint_checked: this.fingerPrintData.fingerprint_checked,
      stripe_fingerprint: this.fingerPrintData.stripe_fingerprint,
      coupon_code: this.storageService.getLocalStore('discount_code')
    };
    this.invoiceUserPlan(userPlanData);
    if (this.fingerPrintData.fingerprint_checked) {
      this.buttonValue = (this.configService.localeKeys?.["plans.start_subscription.btn"] || 'Start subscription');
      this.oldUser = true;
    }
  }

  payment(event) {
    this.backButton = false;
    this.paymentBtnDisabled = true;
    this.baseService.paymentProcessing.next(false);
    this.stripeTest.markAllAsTouched();
    event.preventDefault();
    let paymentData;
    paymentData = {
      type: 'card',
      card: this.cardNumber.element,
      billing_details: {
        name: this.stripeTest.get('name').value,
        email: this.stripeTest.get('email').value,
      },
    };
    if (this.stripeTest.valid) {
      try {
        this.stripeService.createPaymentMethod(paymentData).subscribe(
          (res: any) => {
            this.paymentBtnDisabled = false;
            if (res.error) {
              if (res.code === 'incomplete_number') {
                this.cardNumberValidation = res
              } else if (res.code === 'invalid_expiry_year_past') {
                this.cardExpiryValidation = res;
              } else if (res.code === 'incomplete_cvc') {
                this.cardCvvValidation = res;
              }
            } else {
              this.baseService.paymentProcessing.next(true);
              this.baseService.loaderSource.next(true);
              const paymentMethod = res.paymentMethod.id
              let createSubsObj = {
                session_id: this.subscriptionService.paymentSessionId,
                name: this.stripeTest.get('name').value,
                email: this.stripeTest.get('email').value,
                payment_method: paymentMethod,
                region: this.region,
                locale: this.locale
              };
              if (this.discountType === COUPON && this.couponValid == '1') {
                createSubsObj['coupon_code'] = this.discountCode;
              }
              if (this.fingerPrintData?.fingerprint_checked) {
                this.buttonValue = (this.configService.localeKeys?.["plans.start_subscription.btn"] || 'Start subscription');
                this.oldUser = true;
                createSubsObj['fingerprint_checked'] = this.fingerPrintData.fingerprint_checked;
                createSubsObj['stripe_fingerprint'] = this.fingerPrintData.stripe_fingerprint;
              }
              this.paymentEnteredGTM();
              if (this.freeTrialDays > 0) {
                this.checkFingerPrint(createSubsObj);
              } else {
                if (this.discountType === COUPON && this.couponValid === '1') {
                  createSubsObj['coupon_code'] = this.discountCode;
                }
                this.cardPayItem(createSubsObj);
              }
            }
          }, (error) => {
          });
      } catch (error) {
        console.log('error', error)
      }
    } else this.paymentBtnDisabled = false;
  }

  errorValidation(event) {
    if (event.elementType === 'cardNumber') {
      this.cardNumberValidation = event;
    } else if (event.elementType === 'cardExpiry') {
      this.cardExpiryValidation = event;
    } else if (event.elementType === 'cardCvc') {
      this.cardCvvValidation = event;
    }
  }

  paymentEnteredGTM(): void {
    const uId: string = this.storageService.getLocalStore('u_id');
    const region: string = this.storageService.getLocalStore('region');
    const datalayerData = {
      event: 'GAEvent',
      eventCategory: 'Payment',
      eventAction: 'Payment Entered',
      platform: this.baseService.browserType,
      loginStatus: 'True',
      userId: (uId ? uId : ''),
      notificationStatus: localStorage.getItem('emailNotify') || 'False',
      region: (region ? region : ''),
      userType: this.storageService.getLocalStore('user_type'),
      operator: this.storageService.getLocalStore('operator_name')
    };
    this.datalayerService.addDatalayer(datalayerData);
  }

  paymentCheck(payData): void {
    if (payData?.payment_status === 'PAID') {
      this.paymentSuccessGTM(payData);
    }
  }

  paymentSuccessGTM(payData): void {
    this.storageService.setLocalStore('user_type', 'Paid User');
    const uId: string = this.storageService.getLocalStore('u_id');
    const region: string = this.storageService.getLocalStore('region');
    const datalayerData = {
      event: 'GAEvent',
      eventCategory: 'Payment',
      eventAction: 'Success',
      eventLabel: `${payData?.plan} - ${payData?.currency_code + payData?.original_amount}`,
      eventValue: payData?.currency_code + payData?.original_amount,
      platform: this.baseService.browserType,
      loginStatus: 'True',
      userId: (uId ? uId : ''),
      notificationStatus: localStorage.getItem('emailNotify') || 'False',
      region: (region ? region : ''),
      userType: this.storageService.getLocalStore('user_type'),
      operator: this.storageService.getLocalStore('operator_name')
    };
    this.datalayerService.addDatalayer(datalayerData);
  }

  paymentErrorGTM(errorMsg): void {
    const uId: string = this.storageService.getLocalStore('u_id');
    const region: string = this.storageService.getLocalStore('region');
    const datalayerData = {
      event: 'GAEvent',
      eventCategory: 'Payment',
      eventAction: 'Error',
      eventLabel: errorMsg,
      platform: this.baseService.browserType,
      loginStatus: 'True',
      userId: (uId ? uId : ''),
      notificationStatus: localStorage.getItem('emailNotify') || 'False',
      region: (region ? region : ''),
      userType: this.storageService.getLocalStore('user_type'),
      operator: this.storageService.getLocalStore('operator_name')
    };
    this.datalayerService.addDatalayer(datalayerData);
  }

  ngOnDestroy() {
    this.paymentProcessCheckAlive = false;
    UIkit.modal('#fingerprint-confirm-modal')?.$destroy(true);
    const modelCloseBtn = document.querySelector('.uk-modal-close')
    if (modelCloseBtn) {
      modelCloseBtn.setAttribute('id', 'model-close');
      document.getElementById('model-close').click();
    }
  }

  async createAdyenCheckout() {
    await this.subscriptionService.getIPAddress();
    const clientKey = this.settingService.adyenCleintKey;
    const locale = this.storageService.getLocalStore('locale');
    const countryCode = this.storageService.getLocalStore('country_code');
    const userSelectedPlan = this.storageService.getSessionStore('selectedPlanData');

    const configuration: CoreConfiguration = {
      environment: this.settingService.adyenEnvironment,
      clientKey: clientKey,
      locale: locale,
      countryCode: countryCode,
      paymentMethodsResponse: this.subscriptionService.adyenPaymentMethods,
      amount: {
        value: userSelectedPlan.amount,
        currency: this.applicationService.currencyPrefixSuffix.prefix + this.applicationService.currencyPrefixSuffix.suffix
      },
      onSubmit: async (state, component) => {
        this.adyencomp = component;
        console.log('session id', this.subscriptionService.paymentSessionId);
        const reqObj = await this.subscriptionService.prepareAdyenRequestData(state, userSelectedPlan.pricing_plan_id, this.subscriptionService.paymentSessionId, this.couponValid);
        this.cardPayItem(reqObj);
      },
      onPaymentCompleted(result, component) {
      },
      onPaymentFailed(result, component) {
        this.adyencomp.setStatus('error');
      },
      onError(error) {
        this.adyencomp.setStatus('error');
      }
    };
    if (this.discountType === COUPON && this.couponValid == '1') {
      configuration.amount.value = userSelectedPlan.payable_amount;
    }
    const cardConfiguration = {
      hasHolderName: true,
      holderNameRequired:  true,
      positionHolderNameOnTop: true,
      showPayButton: true
    }

    this.checkout = await AdyenCheckout(configuration);
    const card = new Card(this.checkout, cardConfiguration).mount('#adyen-card-container');
    this.baseService.loaderSource.next(false);
  }

}
